<template>
    <main role="main" class="tc-v2">
        <portal to="ariane">
            <div class="tbv2-page-title">{{ $t('template.create') }}</div>
        </portal>

        <header class="tc-hero">
            <router-link to="/admin/templates" class="tc-back">
                <i class="fal fa-arrow-left"></i>
                <span>{{ $t('common.back') || 'Retour' }}</span>
            </router-link>
            <h1 class="tc-hero-title">{{ $t('template.create') }}</h1>
            <p class="tc-hero-sub">{{ $t('template.create_subtitle') }}</p>
        </header>

        <div v-if="!loading" class="tc-stack">
            <AddTemplate
                v-for="(template, index) in templates"
                :key="`template${template.id}`"
                :formOptions="template.formOptions"
                :index="index"
            />

            <button type="button" class="tc-add-btn" @click="addTemplate">
                <i class="fal fa-plus"></i>
                <span>{{ $t('template.add_another') }}</span>
            </button>
        </div>
    </main>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import { mapActions, mapState } from 'vuex'
import AddTemplate from '@/components/Model/Admin/Template/AddTemplate'

export default {
    name: 'CreateTemplate',
    components: { AddTemplate },
    data() {
        return {
            loading: true,
            formOptions: [],
            templates: []
        }
    },
    methods: {
        ...mapActions('form', ['getForms']),
        addTemplate() {
            this.templates.push({
                id: this.templates.length + 1,
                formOptions: this.formOptions
            })
        }
    },
    created() {
        this.getForms().then(() => {
            this.loading = false
            this.forms.forEach((form) => {
                let translationName
                form.translations.forEach((translation) => {
                    if (translation.locale === this.$i18n.locale) {
                        translationName = translation.name
                    }
                })
                this.formOptions.push({
                    id: form.id,
                    name: translationName
                })
            })
            this.addTemplate()
        })
    },
    computed: {
        ...mapState('form', {
            forms: (state) => state.forms
        })
    }
}
</script>

<style scoped>
.tc-v2 {
    width: 100%;
    max-width: 960px;
    margin: 0 auto;
    padding: 24px 32px 48px;
    font-family: var(--v2-font-sans);
    color: var(--v2-text-2);
}

.tbv2-page-title {
    font-size: 0.95rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
    letter-spacing: -0.005em;
}

.tc-hero {
    margin-bottom: var(--v2-space-5);
}

.tc-back {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: var(--v2-text-xs-size);
    color: var(--v2-text-3);
    text-decoration: none !important;
    margin-bottom: 10px;
    transition: color var(--v2-transition-fast);
}

.tc-back:hover {
    color: var(--v2-primary);
}

.tc-back i {
    font-size: 0.75rem;
}

.tc-hero-title {
    margin: 0 0 6px;
    font-size: 1.75rem;
    font-weight: var(--v2-font-weight-bold);
    color: var(--v2-text-1);
    letter-spacing: -0.02em;
    line-height: 1.15;
}

.tc-hero-sub {
    margin: 0;
    font-size: var(--v2-text-sm-size);
    color: var(--v2-text-3);
    line-height: 1.5;
    max-width: 720px;
}

.tc-stack {
    display: flex;
    flex-direction: column;
    gap: var(--v2-space-4);
}

.tc-add-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 14px;
    background: transparent;
    border: 1.5px dashed var(--v2-border);
    border-radius: var(--v2-radius-lg);
    color: var(--v2-text-3);
    font-size: var(--v2-text-sm-size);
    font-weight: var(--v2-font-weight-semibold);
    cursor: pointer;
    transition: all var(--v2-transition-fast);
}

.tc-add-btn:hover {
    border-color: var(--v2-primary);
    color: var(--v2-primary);
    background: rgba(8, 145, 178, 0.04);
}

.tc-add-btn i {
    font-size: 0.85rem;
}

@media (max-width: 900px) {
    .tc-v2 {
        padding: 16px 18px 32px;
    }

    .tc-hero-title {
        font-size: 1.375rem;
    }
}
</style>
